// extracted by mini-css-extract-plugin
export default {"imageWrapper":"SF-z","hovered":"TF-z","hoverImage":"UF-z","mainImage":"VF-z","imageNoBackground":"WF-z","fullSizeImage":"XF-z"};